"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateScrollTop = updateScrollTop;
exports.startConsecutiveToggle = startConsecutiveToggle;
exports.START_CONSECUTIVE_TOGGLE = exports.UPDATE_SCROLL_TOP = void 0;
var UPDATE_SCROLL_TOP = '@@redux-devtools-log-monitor/UPDATE_SCROLL_TOP';
exports.UPDATE_SCROLL_TOP = UPDATE_SCROLL_TOP;

function updateScrollTop(scrollTop) {
  return {
    type: UPDATE_SCROLL_TOP,
    scrollTop: scrollTop
  };
}

var START_CONSECUTIVE_TOGGLE = '@@redux-devtools-log-monitor/START_CONSECUTIVE_TOGGLE';
exports.START_CONSECUTIVE_TOGGLE = START_CONSECUTIVE_TOGGLE;

function startConsecutiveToggle(id) {
  return {
    type: START_CONSECUTIVE_TOGGLE,
    id: id
  };
}